import React from 'react'

const RemoveIcon = () => {
    return (
        <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.03223 16C13.1572 16 16.5322 12.625 16.5322 8.5C16.5322 4.375 13.1572 1 9.03223 1C4.90723 1 1.53223 4.375 1.53223 8.5C1.53223 12.625 4.90723 16 9.03223 16Z" stroke="#D6D6D6" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M6.91064 10.625L11.1533 6.38236" stroke="black" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M11.1533 10.6176L6.91064 6.375" stroke="black" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
        </svg>

    )
}

export default RemoveIcon
